import { render, staticRenderFns } from "./Statues.vue?vue&type=template&id=75bbe532&"
import script from "./Statues.vue?vue&type=script&lang=js&"
export * from "./Statues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports